import { z } from "zod";

/** Visual annotation semantics; product/component measurements are not packaging dimensions. */
export const ImageMeasurementSchema = z.object({
  label: z.string().min(1).max(100), value: z.number().finite().positive(),
  unit: z.enum(["mm", "cm", "m", "in"]), scope: z.enum(["product", "component", "package", "unknown"]),
  axis: z.enum(["length", "width", "height", "depth", "diameter", "unknown"]), raw: z.string().min(1).max(300),
}).strict();
export const ImageVariantSchema = z.object({
  attributes: z.array(z.object({ name: z.string().min(1).max(80), value: z.string().min(1).max(120) }).strict()).min(1).max(8),
  price: z.object({ amount: z.number().finite().nonnegative(), currency: z.enum(["CNY", "USD", "EUR", "GBP", "unknown"]) }).strict().nullable(),
  stock: z.number().int().nonnegative().nullable(), raw: z.string().min(1).max(500),
}).strict();
export const SourceVisualDetailsSchema = z.object({
  sourceUrl: z.string().max(1200), productIdentity: z.string().max(200), capturedAt: z.string().datetime(),
  measurements: z.array(ImageMeasurementSchema.extend({ imageIndex: z.number().int().min(0).max(7) })).max(80),
  variants: z.array(ImageVariantSchema.extend({ imageIndex: z.number().int().min(0).max(7) })).max(160),
});
export type SourceVisualDetails = z.infer<typeof SourceVisualDetailsSchema>;
